import { filter } from 'lodash';
import * as types from 'login/actions/loginActionTypes.js';

import { ShowroomService } from '@sm360/widget-commons-vehicle';
import { AnalyticsService, DATA_LAYER_VARIABLES as DATA_LAYER_VARS } from '@sm360/widget-commons-general';

function setQuotes(quotes) {
    return { type: types.SET_QUOTES, quotes };
}

export function loadQuotes(isMultiDealerGarage) {
    return (dispatch) => {
        return ShowroomService.loadQuotesV25(isMultiDealerGarage)
            .then((quotes) => {
                dispatch(setQuotes(quotes));
                const hasVehicleInGarage = quotes && quotes.length > 0;
                AnalyticsService.setDataLayerVariable(DATA_LAYER_VARS.HAS_VEHICLE_IN_GARAGE, hasVehicleInGarage);
                AnalyticsService.pushDataLayerVariable(DATA_LAYER_VARS.HAS_VEHICLE_IN_GARAGE, hasVehicleInGarage);
                // Display no of quote in garage - dataLayer
                AnalyticsService.setDataLayerVariable(DATA_LAYER_VARS.ECOMMERCE_GARAGE, quotes.length);
                return quotes;
            })
            .catch((error) => {
                throw error;
            });
    };
}

export function deleteQuote(quote, isMultiDealerGarage) {
    return (dispatch, getState) => {
        const state = getState();

        const config = {
            orgUnitId: quote?.orgUnitId,
            location: quote?.province,
        };

        return ShowroomService.deleteQuoteV25(quote, config, isMultiDealerGarage)
            .then((deletedQuote) => {
                const quotes = filter(state.quotes, (filterQuote) => {
                    return filterQuote.id !== deletedQuote.id;
                });
                dispatch(setQuotes(quotes));
            })
            .catch((error) => {
                throw error;
            });
    };
}
